import {
  getMetricsLabels,
  getQuickviewConfig
} from './metrics'

import {
  getMetricsQuery,
  getNormQuery,
  getGridData,
  getStaticFiltersSelections
} from './scorecard'

import {
  // getMetadataSlices,
  getAdsList,
  getPresets,
  getAdType,
  getAdsMap,
  // getBrandsList,
  // getBrandsMap,
} from './metadata'

import {
  getSelectedPresets,
  getSelectedAds,
  getSelectedTab,
  // getAdSetBuilderStats,
  getStaticFilters,
  getSearchFilter,
  getSortQuery
} from './selections'

export {
  // metrics
  getMetricsLabels,
  getQuickviewConfig,

  // metadata
  // getMetadataSlices,
  getPresets,
  getAdType,
  getAdsMap,
  getAdsList,  
  // getBrandsList,
  // getBrandsMap,
  
  // selections
  getSelectedPresets,
  getSelectedAds,
  getSelectedTab,
  getSearchFilter,
  getStaticFilters,
  // getAdSetBuilderStats,
  getSortQuery,

  // scorecard
  getMetricsQuery,
  getNormQuery,
  getGridData,
  getStaticFiltersSelections

}



// WEBPACK FOOTER //
// ./src/new_selectors/index.js